import React from 'react'

import { useToken } from '@chakra-ui/react'

type CalendarOutlineProps = {
    color?: string
    size?: number
}

export const CalendarOutline: React.FC<CalendarOutlineProps> = ({
    color = 'userInterface.neutral.1000',
    size = 14,
}) => {
    const themeColor = useToken('colors', color)

    return (
        <svg
            width={size}
            height={size}
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M1 7.65C1 5.0103 1 3.6901 1.8204 2.8704C2.6401 2.05 3.9603 2.05 6.6 2.05H9.4C12.0397 2.05 13.3599 2.05 14.1796 2.8704C15 3.6901 15 5.0103 15 7.65V9.05C15 11.6897 15 13.0099 14.1796 13.8296C13.3599 14.65 12.0397 14.65 9.4 14.65H6.6C3.9603 14.65 2.6401 14.65 1.8204 13.8296C1 13.0099 1 11.6897 1 9.05V7.65Z"
                stroke={themeColor}
                strokeWidth="0.875"
                fill="none"
            />
            <path
                d="M4.49998 2.05V1M11.5 2.05V1M1.34998 5.55H14.65"
                stroke={themeColor}
                strokeWidth="0.875"
                strokeLinecap="round"
                fill="none"
            />
            <path
                d="M12.2 11.15C12.2 11.3356 12.1263 11.5137 11.995 11.645C11.8637 11.7762 11.6857 11.85 11.5 11.85C11.3144 11.85 11.1363 11.7762 11.0051 11.645C10.8738 11.5137 10.8 11.3356 10.8 11.15C10.8 10.9643 10.8738 10.7863 11.0051 10.655C11.1363 10.5237 11.3144 10.45 11.5 10.45C11.6857 10.45 11.8637 10.5237 11.995 10.655C12.1263 10.7863 12.2 10.9643 12.2 11.15ZM12.2 8.35C12.2 8.53565 12.1263 8.7137 11.995 8.84497C11.8637 8.97625 11.6857 9.05 11.5 9.05C11.3144 9.05 11.1363 8.97625 11.0051 8.84497C10.8738 8.7137 10.8 8.53565 10.8 8.35C10.8 8.16435 10.8738 7.9863 11.0051 7.85502C11.1363 7.72375 11.3144 7.65 11.5 7.65C11.6857 7.65 11.8637 7.72375 11.995 7.85502C12.1263 7.9863 12.2 8.16435 12.2 8.35ZM8.70005 11.15C8.70005 11.3356 8.6263 11.5137 8.49502 11.645C8.36375 11.7762 8.1857 11.85 8.00005 11.85C7.8144 11.85 7.63635 11.7762 7.50507 11.645C7.3738 11.5137 7.30005 11.3356 7.30005 11.15C7.30005 10.9643 7.3738 10.7863 7.50507 10.655C7.63635 10.5237 7.8144 10.45 8.00005 10.45C8.1857 10.45 8.36375 10.5237 8.49502 10.655C8.6263 10.7863 8.70005 10.9643 8.70005 11.15ZM8.70005 8.35C8.70005 8.53565 8.6263 8.7137 8.49502 8.84497C8.36375 8.97625 8.1857 9.05 8.00005 9.05C7.8144 9.05 7.63635 8.97625 7.50507 8.84497C7.3738 8.7137 7.30005 8.53565 7.30005 8.35C7.30005 8.16435 7.3738 7.9863 7.50507 7.85502C7.63635 7.72375 7.8144 7.65 8.00005 7.65C8.1857 7.65 8.36375 7.72375 8.49502 7.85502C8.6263 7.9863 8.70005 8.16435 8.70005 8.35ZM5.20005 11.15C5.20005 11.3356 5.1263 11.5137 4.99502 11.645C4.86375 11.7762 4.6857 11.85 4.50005 11.85C4.3144 11.85 4.13635 11.7762 4.00507 11.645C3.8738 11.5137 3.80005 11.3356 3.80005 11.15C3.80005 10.9643 3.8738 10.7863 4.00507 10.655C4.13635 10.5237 4.3144 10.45 4.50005 10.45C4.6857 10.45 4.86375 10.5237 4.99502 10.655C5.1263 10.7863 5.20005 10.9643 5.20005 11.15ZM5.20005 8.35C5.20005 8.53565 5.1263 8.7137 4.99502 8.84497C4.86375 8.97625 4.6857 9.05 4.50005 9.05C4.3144 9.05 4.13635 8.97625 4.00507 8.84497C3.8738 8.7137 3.80005 8.53565 3.80005 8.35C3.80005 8.16435 3.8738 7.9863 4.00507 7.85502C4.13635 7.72375 4.3144 7.65 4.50005 7.65C4.6857 7.65 4.86375 7.72375 4.99502 7.85502C5.1263 7.9863 5.20005 8.16435 5.20005 8.35Z"
                fill={themeColor}
            />
        </svg>
    )
}
